import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngxs/store";
import { EventAggregator } from "@vp/data-access/application";
import { GlobalAlertNotificationEvent } from "@vp/models";
import { AlertItem } from "@vp/shared/components/alert";
import { IndividualConfig } from "ngx-toastr";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as SystemBannerActions from "../state/system-banner-action";
import { SystemBannerAdapter } from "./system-banner-adapter.service";

@Component({
  selector: "vp-system-banner",
  standalone: false,
  templateUrl: "./system-banner.component.html",
  styleUrls: ["./system-banner.component.scss"],
  providers: [SystemBannerAdapter]
})
export class SystemBannerComponent implements OnInit, OnDestroy {
  alertConfig: Partial<IndividualConfig> = {
    positionClass: "inline",
    tapToDismiss: false,
    closeButton: true,
    disableTimeOut: true,
    enableHtml: true
  };

  private readonly destroyed$ = new Subject<void>();

  constructor(
    private readonly systemBannerAdapter: SystemBannerAdapter,
    private readonly eventAggregator: EventAggregator,
    private readonly store: Store
  ) {}

  banners$ = this.systemBannerAdapter.banners$.pipe(takeUntil(this.destroyed$));

  ngOnInit(): void {
    this.eventAggregator
      .on<GlobalAlertNotificationEvent>(GlobalAlertNotificationEvent)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(event => this.store.dispatch(new SystemBannerActions.AddGlobalAlert(event.args)));
  }

  alertDismissed(alertItem: AlertItem) {
    this.systemBannerAdapter.dismissBanner(alertItem);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
